module.exports = __webpack_public_path__ + "img/Sign_2.ff8394d9.png";